<template>
  <div>
    <div class="menu row" :class="{'d-none': !active}">
      <div class="menu_item action-menu-tagging" v-if="changeProgram && action == 'view' ">
        <b-btn class="btn_ic ace_sec" @click.stop="getUserUuid1" aria-label="Change Program" title="Change Program">
          <span class="icon ic24-degreeProgram"></span>
        </b-btn>
      </div>
      <div class="menu_item action-menu-tagging" v-if="!isProspectiveStudent && action == 'view' ">
        <b-btn class="btn_ic ace_sec" @click.stop="getUserUuid" aria-label="Act as User" title="Act as User" tabindex="0">
          <span class="icon ic24-mask action-icon-mask"></span>
        </b-btn>
      </div>
      <div class="menu_item action-menu-tagging">
        <tagging-action-menu ref="taggingActionMenu" :user-ids="userIds" :sender-id="senderId"></tagging-action-menu>
      </div>
      <div class="menu_item action-menu-calendar" v-if="isCalendarEnabled">
        <calendar-event-action-menu ref="calendarEventActionMenu" :user-ids="userIds" :sender-id="senderId"></calendar-event-action-menu>
      </div>
      <div class="menu_item action-menu-note" v-if="!isProspectiveStudent">
        <note-action-menu ref="noteActionMenu" :action="action" :user-ids="userIds" :sender-id="senderId"></note-action-menu>
      </div>
      <div class="menu_item action-menu-channel" v-if="!isProspectiveStudent">
        <channel-action-menu ref="channelActionMenu" :action="action" :user-ids="userIds" :sender-id="senderId"></channel-action-menu>
      </div>
    </div>
    <div v-if="!active">
      <template v-if="unreadCount > 0">
        <button class="ic_btn ic9-iconMore-0005 dotted-menu ace_sec">
          <span class="red-dot"></span>
        </button>
      </template>
      <template v-else>
        <button class="ic_btn ic9-iconMore-0005 dotted-menu ace_sec"></button>
      </template>
    </div>
  </div>
</template>

<script>
  import NoteActionMenu from './NoteActionMenu'
  import ChannelActionMenu from './ChannelActionMenu'
  import TaggingActionMenu from './TaggingActionMenu'
  import CalendarEventActionMenu from './CalendarEventActionMenu'
  import { PACKAGE } from '../../../package_constants'
  import { mapState } from 'vuex'

  export default {
    name: 'channel-calendar-note-action-menu',
    props: ['action', 'userIds', 'senderId', 'active', 'isProspectiveStudent', 'changeProgram'],
    data: () => {
      return {
        unreadCount: 0
      }
    },
    components: {
      NoteActionMenu,
      ChannelActionMenu,
      TaggingActionMenu,
      CalendarEventActionMenu
    },
    methods: {
       async showChangeProgram () {

      },
      async getUserUuid1 () {
        let userUuids = _.map(this.userIds, 'userUuid')
        this.$parent.openChangeProgramModal(userUuids)
      },
      async getUserUuid () {
        let userUuids = _.map(this.userIds, 'userUuid')
        this.$parent.openActAsUserModal(userUuids)
      },

    },
    computed: {
      ...mapState({
        'enabledFeatures': state => state.institution.enabledFeatures
      }),
      isCalendarEnabled () {
        let calendar = this.enabledFeatures[PACKAGE.FEATURE_IDS.CALENDAR]
        if (calendar && calendar.enabled) {
          return true
        }
        return false
      }
    }
  }
</script>

<style scoped>
  .action-icon-mask {
    width: 23px;
    float: left;
    display: inline-block;
    margin: -10px 25px 0px -15px;
    cursor: pointer;
    font-size: 50px;
  }
  .action-menu-tagging {
    width: 23px;
    float: left;
    display: inline-block;
    margin: 10px 8px 0px 5px;
    cursor: pointer;
  }

  .action-menu-calendar {
    width: 23px;
    float: left;
    display: inline-block;
    margin: 8px 5px 0px 6px;
    cursor: pointer;
  }

  .action-menu-note {
    width: 24px;
    float: left;
    display: inline-block;
    margin: 9px 2px 0px 5px;
    cursor: pointer;
  }

  .action-menu-channel {
    width: 25px;
    float: left;
    display: inline-block;
    margin: 4px;
    cursor: pointer;
  }

  .dotted-menu {
    float: left;
    margin-left: 12px;
    font-size: 30px;
    cursor: pointer;
    margin-top: -2px;
  }
  .red-dot {
    width: 10px;
    height: 10px;
    margin: 4px -6px;
    position: absolute;
    border-radius: 50%;
    border: 1px solid #ccc;
    background-color: #c31a00;
  }
</style>



// WEBPACK FOOTER //
// src/app/adviseeTracker/components/ChannelCalendarNoteActionMenu.vue